import { render, staticRenderFns } from "./ClientItem.vue?vue&type=template&id=3c197f3c&"
import script from "./ClientItem.vue?vue&type=script&lang=ts&"
export * from "./ClientItem.vue?vue&type=script&lang=ts&"
import style0 from "./ClientItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
